exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".CheckBox__checkBoxDisabled__2t2p5{cursor:not-allowed!important;opacity:.5}.CheckBox__checkBoxDisabled__2t2p5 input{cursor:not-allowed!important}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/CheckBox.scss"],"names":[],"mappings":"AAAA,mCACI,6BAA8B,AAC9B,UAAW,CAKd,AAPD,yCAKQ,4BAA8B,CACjC","file":"CheckBox.scss","sourcesContent":[".checkBoxDisabled {\n    cursor: not-allowed !important;\n    opacity: .5;\n\n    input {\n        cursor: not-allowed !important;\n    }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"checkBoxDisabled": "CheckBox__checkBoxDisabled__2t2p5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/CheckBox.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/CheckBox.scss
// module chunks = 0